import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateMaterial as updateMaterialApi } from "../../../../services/dashboard/apiLecture";
import toast from "react-hot-toast";

function useUpdateMaterial() {
  const queryClient = useQueryClient();

  const {
    mutate: updateMaterial,
    isPending: isUpdating,
    error,
  } = useMutation({
    mutationFn: updateMaterialApi,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["lectureMaterials"] });
      toast.success("تم تعديل بيانات الملف بنجاح");
    },
    onError: (error) => {
      toast.error(error.response.data.message);
    },
  });

  return { updateMaterial, isUpdating, error };
}

export default useUpdateMaterial;
